import {BrowserRouter, Route, Routes} from "react-router";
import React, {useEffect, useState} from "react";
import {createTheme, ThemeProvider} from "@mui/material";
import {blueGrey, pink} from "@mui/material/colors";
import Profile from "./profile/Profile";
import {FirebaseApp} from "firebase/app";
import {Edit} from "./edit/Edit";
import {Home} from "./home/Home";
import {getAdditionalUserInfo, getAuth, GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import {collection, getDocs, getFirestore, query, where} from "firebase/firestore";
import {Session} from "./auth/session";
import {Authentication} from "./auth/Authentication";

const theme = createTheme({
    colorSchemes: {
        dark: true,
    },
});

interface Props {
    session: Session | null;
    firebase: FirebaseApp;
}

function App(props: Props) {
    const auth = getAuth(props.firebase);
    const store = getFirestore(props.firebase);
    const [session, setSession] = useState<Session | null>(props.session);
    const provider = new GoogleAuthProvider();

    async function doAuth() {
        try {
            const result = await signInWithPopup(auth, provider);
            const credential = GoogleAuthProvider.credentialFromResult(result);
            if (!credential) {
                return;
            }

            const user = result.user;
            const info = getAdditionalUserInfo(result);

            const uid = user.uid;
            const name: string = info?.profile?.given_name as string || user.displayName || "User";
            localStorage.setItem("uid", uid);
            localStorage.setItem("name", name);

            let username: string | null = null;
            const q = query(collection(store, "wayfares"), where("uid", "==", uid));
            const existing = await getDocs(q);
            existing.forEach((doc) => {
                username = doc.id;
                localStorage.setItem("username", username);
            });

            setSession({
                uid: uid,
                username: username,
                name: name,
            });
        } catch (error: any) {
            const errorCode = error.code;
            const errorMessage = error.message;
            alert("Could not sign in: " + errorMessage + " (" + errorCode + ")");
        }
    }

    const notFound = <main style={{padding: "1rem"}}>
        <p>There's nothing here!</p>
    </main>;

    return <ThemeProvider theme={theme}>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/auth" element={<Authentication auth={auth} session={session} doAuth={doAuth} />} />
                <Route path="/my-wayfare" element={<Edit session={session} store={store} />} />
                <Route path="/:username" element={<Profile store={store} />}/>
                <Route path="*" element={notFound}/>
            </Routes>
        </BrowserRouter>
    </ThemeProvider>
}

export default App;
